/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { IdName } from 'src/app/shared/models/id-name';
import { IWorkPlanTemplate } from '../models/work-plan-template.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class WorkPlanTemplateApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/WorkPlanTemplates`;
  }

  constructor(private http: HttpClient) {}

  loadWorkPlanTemplates(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IWorkPlanTemplate[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IWorkPlanTemplate[]>>(this.url, { params });
  }

  loadAllWorkPlans(): Observable<IdName[]> {
    const url = `${this.url}/All`;
    const params = new HttpParams().set('DepartmentId', getDepartmentId());
    return this.http.get<IdName[]>(url, { params });
  }

  loadWorkPlanById(id: string): Observable<IWorkPlanTemplate> {
    const url = `${this.url}/${id}`;
    return this.http.get<IWorkPlanTemplate>(url);
  }

  createWorkPlan(workPlan: IWorkPlanTemplate): Observable<IWorkPlanTemplate> {
    return this.http.post<IWorkPlanTemplate>(this.url, workPlan, { headers });
  }

  updateWorkPlan(workPlan: IWorkPlanTemplate): Observable<IWorkPlanTemplate> {
    const url = `${this.url}/${workPlan.id}`;
    return this.http.put<IWorkPlanTemplate>(url, workPlan, { headers });
  }

  deleteWorkPlan(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
